// Validating the employee signatures

// This will validate the employee signatures for the JSA form, it will need a draft validation and a submitted validation

// Draft validation
export const validateJsaEmployeeSignaturesDraft = (
  jsaEmployeeSignaturesInfo
) => {
  const errors = [];

  // Going through each employee signature info
  jsaEmployeeSignaturesInfo.forEach((employee) => {
    // For draft validation, only flag an error if the row has been partially filled
    // (i.e., if there's a signature but no employee, or vice versa)
    // Empty rows are acceptable in draft mode
    const hasEmployeeId = employee.employeeId && employee.employeeId !== "";
    const hasSignature = employee.employeeSig && employee.employeeSig !== "";

    // Only validate if the row has any data at all
    if (hasEmployeeId || hasSignature) {
      const employeeError = {
        rowId: employee.rowId,
        errors: {
          employeeId: "",
          employeeSig: "",
        },
      };

      // If there's a signature but no employee ID, that's an error
      if (hasSignature && !hasEmployeeId) {
        employeeError.errors.employeeId =
          "Employee ID is required when signature is present";
      }

      // Only push if there are actual errors
      if (employeeError.errors.employeeId || employeeError.errors.employeeSig) {
        errors.push(employeeError);
      }
    }
  });

  return errors;
};

// Submitted validation
export const validateJsaEmployeeSignaturesSubmitted = (
  jsaEmployeeSignaturesInfo
) => {
  const errors = [];

  // Going through each employee signature info
  jsaEmployeeSignaturesInfo.forEach((employee) => {
    // Creating an employee signature info error object
    const employeeError = {
      rowId: employee.rowId,
      errors: {
        employeeId: "",
        employeeSig: "",
      },
    };

    // Checking if the employee id is empty
    if (!employee.employeeId || employee.employeeId === "") {
      employeeError.errors.employeeId = "Employee ID is required";
    }

    // Checking if the employee signature is empty
    if (!employee.employeeSig || employee.employeeSig === "") {
      employeeError.errors.employeeSig = "Employee signature is required";
    }
    if (employeeError.errors.employeeId || employeeError.errors.employeeSig) {
      errors.push(employeeError);
    }
  });

  return errors;
};
